import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { CompanyIdService } from '../../services/company-id.service';

@Component({
  selector: 'app-homepage',
  imports: [CommonModule],
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {
  private companyGuid: string | null = null;
  public hasValidGuid: boolean = false;
  public isLoading: boolean = true;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private companyIdService: CompanyIdService
  ) {
    console.log('Homepage: Constructor called');
  }

  ngOnInit(): void {
    
    // Handle encoded company ID query parameter
    this.route.queryParams.pipe(take(1)).subscribe(async params => {
      
      const encodedId = params['cid'] || null;
      
      if (encodedId) {
        try {
          // Decode the company GUID from the encoded ID
          this.companyGuid = this.companyIdService.decode(encodedId);
          this.hasValidGuid = !!this.companyGuid;
          
          // Log decoding info for debugging
          const info = this.companyIdService.getEncodingInfo(encodedId);
        } catch (error) {
          this.companyGuid = null;
          this.hasValidGuid = false;
        }
      } else {
        this.companyGuid = null;
        this.hasValidGuid = false;
      }
      
      this.isLoading = false;
      
      // if (!this.hasValidGuid) {
      //   console.warn('Homepage: No valid company ID found, redirecting to error page');
      //   this.router.navigate(['/error/guid-missing']);
      // } else {
      //   console.log('Homepage: Valid GUID found, showing homepage content');
      // }
    });
  }



  startBuilding(): void {
    
    // Only proceed if we have a valid GUID
    if (!this.hasValidGuid || !this.companyGuid) {
      this.router.navigate(['/error/guid-missing']);
      return;
    }
    
    // Encode the company GUID for the builder route
    const encodedId = this.companyIdService.encode(this.companyGuid);
    
    // Navigate to builder with encoded company ID
    this.router.navigate(['/builder'], { 
      queryParams: { cid: encodedId } 
    });
  }

  startBuildingV2(): void {
    // if (!this.hasValidGuid || !this.companyGuid) {
    //   this.router.navigate(['/error/guid-missing']);
    //   return;
    // }
    // Encode the company GUID for the V2 builder route
    const encodedId = this.companyIdService.encode(this.companyGuid || '');
    
    // Navigate to V2 form builder with encoded company ID
    this.router.navigate(['/form-builder-v2'], { 
      queryParams: { cid: encodedId } 
    });
  }
} 